module.exports = __webpack_public_path__ + "img/shop_kusen.e9b4a37d.jpg";